import { Observable } from 'rxjs'

import {
  ACTION_SET_NG_ANS,
  getStoryAns,
  getAnsLoadStatus,
  Statuses,
} from '~/redux/storyData'

/**
 * Get latest story object from Redux store and set it to Angular
 */
const setNgStoryEpic = (
  action$,
  store,
  { serviceResolver } // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Observable<any> =>
  action$
    .filter((action) => {
      const state = store.getState()
      return (
        action.type === ACTION_SET_NG_ANS &&
        getAnsLoadStatus(state) !== Statuses.Disabled
      )
    })
    .do((action) => {
      const reduxStory = getStoryAns(store.getState())
      // .setStory is required to trigger $onChanges of angular components which rely on a new object reference
      serviceResolver('storyService').setStory(
        reduxStory,
        action.payload.isDirty
      )
    })
    .filter(() => false)

export default setNgStoryEpic
